import { ServiceType } from '@common/enums';
import { BackupHistoryItem } from '@common/models';
import { getServiceUiInfo, roundToFixed, ServiceColors } from '@common/utils';
import { I18NextPipe } from 'angular-i18next';
import { ChartDataset } from 'chart.js';

type OPTIONS = {
  allowedTypes: ServiceType[];
  data: BackupHistoryItem[];
  i18n: I18NextPipe;
  serviceType: ServiceType;
};

export function prepareLastDaysBackupSizeDataSet(options: OPTIONS): ChartDataset[] {
  const { data, serviceType, allowedTypes = [], i18n } = options;

  if (serviceType === ServiceType.All && data?.length > 0) {
    const allTypes: ServiceType[] = [];

    for (const [key] of Object.entries(data[0].Usage)) {
      if (ServiceType[key] >= 0 && allowedTypes.includes(ServiceType[key])) {
        allTypes.push(ServiceType[key]);
      }
    }

    return allTypes.map((type: ServiceType) => {
      const arrayData = data.reduce(
        (acc: BackupHistoryItem[], item: BackupHistoryItem) => [...acc, roundToFixed.format(item.Usage[ServiceType[type]])],
        []
      );

      return {
        data: arrayData,
        label: i18n.transform(getServiceUiInfo(type).i18nKey, { format: 'capitalize' }),
        backgroundColor: ServiceColors[ServiceType[type]] as ServiceColors,
        hoverBackgroundColor: ServiceColors[ServiceType[type]] as ServiceColors
      };
    }) as ChartDataset[];
  } else {
    const arrayData = data.reduce(
      (acc: BackupHistoryItem[], item: BackupHistoryItem) => [...acc, roundToFixed.format(item.Usage[ServiceType[serviceType]])],
      []
    );
    return [
      {
        data: arrayData,
        label: i18n.transform(getServiceUiInfo(serviceType).i18nKey, { format: 'capitalize' }),
        backgroundColor: ServiceColors[ServiceType[serviceType]] as ServiceColors,
        hoverBackgroundColor: ServiceColors[ServiceType[serviceType]] as ServiceColors
      }
    ] as ChartDataset[];
  }
}
